import React, { useEffect } from "react";

import type { IItem } from "./MenuItem";

export type UseMenuEffectsParams = {
	items: IItem[];
	openingSide: "left" | "right" | "center";
	openOnHover: boolean | undefined;
	isSuperAdmin: boolean;
	loadingPermissions: boolean;
	subMenuRef: React.RefObject<HTMLDivElement>;
	iconRef: React.RefObject<HTMLDivElement>;
	close: () => void;
	openOnHoverProp: boolean | undefined;
	isOpen: boolean;
	isHovered: boolean;
};

function useMenuClickOutside(
	subMenuRef: React.RefObject<HTMLDivElement>,
	iconRef: React.RefObject<HTMLDivElement>,
	close: () => void,
	isSubMenuVisible: boolean,
): void {
	useEffect(() => {
		if (!isSubMenuVisible) {
			return;
		}
		const handleClickOutside = (e: MouseEvent): void => {
			if (
				subMenuRef.current &&
				!subMenuRef.current.contains(e.target as Node) &&
				iconRef.current &&
				!iconRef.current.contains(e.target as Node)
			) {
				close();
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return (): void => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [close, subMenuRef, iconRef, isSubMenuVisible]);
}

export function useMenuEffects(params: UseMenuEffectsParams): void {
	const { subMenuRef, iconRef, close, openOnHover, isOpen, isHovered } = params;
	const isSubMenuVisible = (!openOnHover && isOpen) || (!!openOnHover && isHovered);

	useMenuClickOutside(subMenuRef, iconRef, close, isSubMenuVisible);
}
